import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { CoreActions } from './actions';
import { CoreState } from './store';

@Injectable({
    providedIn: 'root'
})
export class CoreService {
    constructor(
        private actions: CoreActions,
        private ngRedux: NgRedux<CoreState>
    ) {}

    setSelectedLanguage(lang) {
        this.ngRedux.dispatch(this.actions.setSelectedLanguage(lang));
    }
}
